const CATEGORY_TYPES = [
  'freeAppointmentObjectSale',
  'freeAppointmentObjectRent',
  'industrySale',
  'industryRent',
  'officeSale',
  'officeRent',
  'shoppingAreaSale',
  'shoppingAreaRent',
  'warehouseSale',
  'warehouseRent',
];

/** Определяет вхождение категории в список возможных купить/снять частично */
export const isObjectSplitsCategory = (category) => CATEGORY_TYPES.includes(category);
